<template>
  <div class="product-list-page">
   <!-- 导航栏 -->
   <Header  />
    <!-- 分类筛选栏 -->
    <section class="category-filter">
      <div class="filter-container">
        <div 
          v-for="category in categories" 
          :key="category.categoryId"
          class="filter-item"
          :class="{ active: selectedCategory === category.categoryId }"
          @click="selectCategory(category.categoryId)"
        >
          <span class="filter-icon">
            <svg v-if="category.icon === 'icon-all'" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5">
              <rect x="3" y="3" width="7" height="7" rx="1"/>
              <rect x="14" y="3" width="7" height="7" rx="1"/>
              <rect x="3" y="14" width="7" height="7" rx="1"/>
              <rect x="14" y="14" width="7" height="7" rx="1"/>
            </svg>
            <svg v-else-if="category.icon === 'icon-drone'" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M12 2L2 7l10 5 10-5-10-5z"/>
              <path d="M2 17l10 5 10-5"/>
              <path d="M2 12l10 5 10-5"/>
            </svg>
            <svg v-else-if="category.icon === 'icon-project'" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5">
              <rect x="3" y="3" width="18" height="18" rx="2"/>
              <path d="M3 9h18"/>
              <path d="M9 21V9"/>
            </svg>
            <svg v-else-if="category.icon === 'icon-team'" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
              <circle cx="9" cy="7" r="4"/>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
          </span>
          <span class="filter-name">{{ category.categoryName }}</span>
        </div>
      </div>
    </section>

    <!-- 产品列表 -->
    <section class="product-grid-section">
      <div class="product-grid">
        <div v-for="product in products" :key="product.productId" class="product-card">
          <div class="product-image" @click="goToDetail(product.productId)">
            <img :src="getFullImageUrl(product.imageUrl)" :alt="product.productName" />
          </div>
          <div class="product-info">
            <h3 class="product-name" @click="goToDetail(product.productId)">{{ product.productName }}</h3>
            <button class="btn-booking" @click="openBookingDialog(product)">立即预约</button>
            <div class="product-stats">
              <span class="test-count">已测试<span class="highlight">{{ product.testCount }}</span>次</span>
              <span class="satisfaction">满意度<span class="highlight">{{ product.satisfactionRate }}</span></span>
            </div>
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          v-model:current-page="queryParams.pageNum"
          v-model:page-size="queryParams.pageSize"
          :total="total"
          :page-sizes="[16, 32, 48]"
          layout="prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </section>

    <!-- 引入 Footer -->
    <Footer />
    <!-- 预约弹框 -->
    <BookingDialog 
      v-model:visible="bookingDialogVisible" 
      :product="selectedProduct"
      @success="handleBookingSuccess"
    />
  </div>
</template>

<script setup>
	import Header from '@/components/Header.vue'
	import Footer from '@/components/Footer.vue'
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { getMenuTree, getFooterTree, getContact } from '@/api/website'
import { getProductCategories, getProducts } from '@/api/product'
import BookingDialog from '@/components/BookingDialog.vue'

const router = useRouter()

const BASE_URL = process.env.VUE_APP_BASE_URL || ''

const menuTree = ref([])
const categories = ref([])
const products = ref([])
const total = ref(0)
const selectedCategory = ref(0)
const selectedProduct = ref(null)
const bookingDialogVisible = ref(false)

const queryParams = ref({
  pageNum: 1,
  pageSize: 16,
  categoryId: null
})

const contactInfo = ref({
  phone: '111-1111-111',
  email: 'san@san@san@san.com',
  address: '上海市浦东新区张江高科技园区',
  qrCodeUrl: ''
})

const footerLinks = ref([])

const getFullImageUrl = (url) => {
  if (!url) return ''
  if (url.startsWith('http')) return url
  return BASE_URL + encodeURI(url)
}

// const qrCodeImageUrl = computed(() => {
//   return getFullImageUrl(contactInfo.value.qrCodeUrl)
// })

// const goHome = () => {
//   router.push('/')
// }

// const handleMenuClick = (menu) => {
//   if (menu.menuName === '多功能通用无人机H1') {
//     router.push('/products')
//   }
// }

// const handleSubMenuClick = (sub) => {
//   if (sub.menuName === '产品介绍') {
//     router.push('/product/1')
//   }
// }

const selectCategory = (categoryId) => {
  selectedCategory.value = categoryId
  queryParams.value.categoryId = categoryId === 1 ? null : categoryId
  queryParams.value.pageNum = 1
  loadProducts()
}

const loadProducts = async () => {
  try {
    const res = await getProducts(queryParams.value)
    if (res.code === 200) {
      products.value = res.rows || []
      total.value = res.total || 0
    }
  } catch (error) {
    console.error('加载产品列表失败:', error)
  }
}

const handleSizeChange = (val) => {
  queryParams.value.pageSize = val
  loadProducts()
}

const handleCurrentChange = (val) => {
  queryParams.value.pageNum = val
  loadProducts()
}

const goToDetail = (productId) => {
  router.push(`/product/${productId}`)
}

const openBookingDialog = (product) => {
  selectedProduct.value = product
  bookingDialogVisible.value = true
}

const handleBookingSuccess = () => {
  loadProducts()
}

const loadData = async () => {
  try {
    const [menuRes, categoryRes, footerRes, contactRes] = await Promise.all([
      getMenuTree(),
      getProductCategories(),
      getFooterTree(),
      getContact()
    ])

    if (menuRes.code === 200 && menuRes.data) {
      menuTree.value = menuRes.data
    }

    if (categoryRes.code === 200 && categoryRes.data) {
      categories.value = categoryRes.data
    }

    if (footerRes.code === 200 && footerRes.data) {
      footerLinks.value = footerRes.data.map(footer => ({
        title: footer.footerName,
        links: footer.children ? footer.children.map(child => child.footerName) : []
      }))
    }

    if (contactRes.code === 200 && contactRes.rows?.length > 0) {
      const contact = contactRes.rows[0]
      contactInfo.value = {
        phone: contact.hotline || contact.phone || '111-1111-111',
        email: contact.email || 'san@san@san@san.com',
        address: contact.address || '上海市浦东新区张江高科技园区',
        qrCodeUrl: contact.qrCodeUrl || ''
      }
    }

    await loadProducts()
  } catch (error) {
    console.error('加载数据失败:', error)
  }
}

onMounted(() => {
  loadData()
})
</script>

<style scoped>
.product-list-page {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  line-height: 1.5;
  color: #333;
  max-width: 1440px;
  margin: 0 auto;
  background: #fff;
  box-shadow: 0 0 20px rgba(0,0,0,0.05);
  min-height: 100vh;
}

/* 分类筛选栏 */
.category-filter {
  margin-top: 100px;
  padding: 30px 60px;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
}

.filter-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  background: #fff;
}

.filter-item:hover {
  border-color: #4a90e2;
  color: #4a90e2;
}

.filter-item.active {
  border-color: #4a90e2;
  color: #4a90e2;
  background: #f0f7ff;
}

.filter-icon {
  display: flex;
  align-items: center;
}

.filter-name {
  font-size: 14px;
  font-weight: 500;
}

/* 产品网格 */
.product-grid-section {
  padding: 40px 60px;
  min-height: 600px;
}

.product-grid {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.product-card {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.2s;
  padding: 16px;
}

.product-card:hover {
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
}

.product-image {
  width: calc(100% - 8px);
  height: 200px;
  overflow: hidden;
  cursor: pointer;
  border-radius: 8px;
  margin: 0 4px 16px;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.3s;
}

.product-image:hover img {
  transform: scale(1.05);
}

.product-info {
  padding: 0;
}

.product-name {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 16px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}

.product-name:hover {
  color: #4a90e2;
}

.btn-booking {
  width: 100%;
  padding: 10px 0;
  background: #fff;
  border: 1px solid #4a90e2;
  border-radius: 4px;
  color: #4a90e2;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  margin-bottom: 12px;
}

.btn-booking:hover {
  background: #4a90e2;
  color: #fff;
}

.product-stats {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #666;
}

.test-count {
  color: #666;
}

.test-count .highlight {
  color: #4a90e2;
  font-weight: 600;
}

.satisfaction {
  color: #666;
}

.satisfaction .highlight {
  color: #4a90e2;
  font-weight: 600;
}

/* 分页 */
.pagination-wrapper {
  max-width: 1200px;
  margin: 40px auto 0;
  display: flex;
  justify-content: center;
}


</style>
